import React, { Component, Fragment } from 'react';
import {TextField, Box, FormControl, InputLabel, FormHelperText, Checkbox} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import useAutoComplete from '@mui/material/useAutocomplete'
import { isEmpty } from 'lodash';

// if (typeof newValue === 'string') {
//     // timeout to avoid instant validation of the dialog's form.
//     setTimeout(() => {
//     toggleOpen(true);
//     setDialogValue({
//         title: newValue,
//         year: '',
//     });
//     });
// } else if (newValue && newValue.inputValue) {
//     toggleOpen(true);
//     setDialogValue({
//     title: newValue.inputValue,
//     year: '',
//     });
// } else {
//     setValue(newValue);
// }
// }}

// const top100Films = [
//     { title: 'The Shawshank Redemption', year: 1994 },
//     { title: 'The Godfather', year: 1972 },
//     { title: 'The Godfather: Part II', year: 1974 },
//     { title: 'The Dark Knight', year: 2008 },
//     { title: '12 Angry Men', year: 1957 },
//     { title: "Schindler's List", year: 1993 }
// ]
const filter = createFilterOptions();

class Creatable extends Component {
    state = {  }
    render() {
        const { options, value, label, error, required, name, title, id, helperText, multiple, disabled } = this.props
        return (
            <Box p={1} style={{width: "100%"}}>
                <FormControl variant="outlined" style={{width: "100%"}} error={!!error} required={required}>
                    <Autocomplete
                        onChange={(event, newValue) => {
                            if (typeof newValue === 'string' && this.props.openPopUp) {
                                // timeout to avoid instant validation of the dialog's form.
                                setTimeout(() => this.props.openPopUp(newValue));
                            } else if (newValue && newValue.inputValue && this.props.openPopUp) {
                                this.props.openPopUp(newValue.inputValue)
                            } else {
                                this.props.onChange(newValue)
                            }
                        }}
                        filterOptions={(options, params) => {
                            const filtered = filter(options, params);        
                            if (params.inputValue !== '' && this.props.openPopUp) {
                                filtered.push({
                                    inputValue: params.inputValue,
                                    label: `Ajouter "${params.inputValue}"`,
                                });
                            }
                            return filtered;
                        }}
                        value={value}
                        options={options}
                        id={id}
                        required={required}
                        getOptionLabel={(option) => {
                            // e.g value selected with enter, right from the input
                            if(isEmpty(option)){
                               return "" 
                            }
                            if (typeof option === 'string') {
                                return option;
                            }
                            if (option.inputValue) {
                                return option.inputValue;
                            }
                            return option.label;
                        }}
                        getOptionDisabled={(option) => option.disabled}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                {/* <Checkbox
                                    // icon={icon}
                                    // checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                /> */}
                                {option.label}
                            </li>
                        )}
                        // renderOption={(option) => option.label}
                        style={{ width: "100%" }}
                        renderInput={(params) => (
                            <TextField {...params} label={label} variant="outlined" error={!!error}/>
                        )}
                        selectOnFocus
                        clearOnBlur
                        handleHomeEndKeys
                        freeSolo
                        disabled={disabled}
                        multiple={multiple}
                        PopperProps={{
                            style: { zIndex: 13002 },
                            sx: { zIndex: 13002 }
                        }}
                        ListboxProps={{
                            style: { zIndex: 13002 }
                        }}
                        componentsProps={{
                            popper: {
                                style: { zIndex: 13002 },
                                sx: { zIndex: 13002 }
                            }
                        }}
                    />
                    <FormHelperText>{error || helperText}</FormHelperText>
                </FormControl>
            </Box>
        );
    }
}

export default Creatable;